import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Layout } from '@prlw/common/layout/layout.enum';
import { IPage } from '@prlw/common/page/page.interface';
import { BehaviorSubject, tap } from 'rxjs';
import { ResponsiveService } from '@prlw/libs/responsive/responsive.service';
import { SyncScrollService } from '@prlw/libs/sync-scroll/sync-scroll.service';
import { MainTableInstrumentsService } from '@prlw/core/monitor/main-table-instruments.service';
import { mapResult } from '@prlw/infrastructure/observableWithPending-v2';
import { ProductGroupsService } from '@prlw/core/products/product-groups.service';
import { Router } from '@angular/router';

@Component({
  selector: 'prlw-monitor-page',
  templateUrl: './monitor.page.html',
  styleUrls: ['./monitor.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SyncScrollService],
})
export class MonitorPage implements IPage, OnDestroy {
  public readonly headerTitle = 'Маркет монитор';
  public readonly pageTitle = 'Маркет монитор';
  public readonly layout = Layout.Primary;

  isBasisBestPriceMobileOutOfIntersection$ = new BehaviorSubject(false);
  observer: IntersectionObserver | null = null;
  elBasisBestPriceMobile: ElementRef | null = null;
  @ViewChild('basisBestPriceMobile', { read: ElementRef })
  set basisBestPriceMobile(el: ElementRef | undefined) {
    if (el) {
      setTimeout(() => {
        this.elBasisBestPriceMobile = el;
        this.observer = new IntersectionObserver(
          (items) => {
            const [hasRootBoundsFirstItem] = items.filter(
              (item) => !!item.rootBounds,
            );
            this.isBasisBestPriceMobileOutOfIntersection$.next(
              !(hasRootBoundsFirstItem?.isIntersecting ?? false),
            );
          },
          {
            /**
             * 100px added at the bottom to prevent cases
             * when target height gte root height
             */
            rootMargin: '-165px 0px 100px 0px',
            threshold: [1],
          },
        );
        this.observer.observe(this.elBasisBestPriceMobile.nativeElement);
      }, 0);
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
      if (this.elBasisBestPriceMobile) {
        this.observer.unobserve(this.elBasisBestPriceMobile.nativeElement);
      }
    }
  }

  constructor(
    private readonly productGroupsService: ProductGroupsService,
    private readonly mainTableInstrumentsService: MainTableInstrumentsService,
    private readonly responsiveService: ResponsiveService,
    private readonly router: Router,
  ) {}

  currentProductGroupCode$ =
    this.productGroupsService.currentProductGroupCode$.pipe(
      tap((code) => {
        this.router.navigate(['monitor', code]);
      }),
    );

  xsmall$ = this.responsiveService.xsmall$;
  reqInstrumentsResult$ =
    this.mainTableInstrumentsService.reqInstrumentsWithPending$.pipe(mapResult);
}
